import React, { useState } from 'react';
import { ToggleButton, ToggleWrap, Content } from './DevicesStyles';
import { PageContainer, PageHeader, PageTitle } from '../../components/PageLayout';
import TestRegisterDevice from './components/TestRegisterDevice/TestRegisterDevice';
import DevicesUnconfiguredList from './components/DevicesUnconfiguredList/DevicesUnconfiguredList';
import DevicesConfiguredList from './components/DevicesConfiguredList/DevicesConfiguredList';

type Tab = 'CONFIGURED' | 'UNCONFIGURED' | 'TEST';

const Devices: React.FC = () => {
    const [tab, setTab] = useState<Tab>('CONFIGURED');

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle>Devices</PageTitle>
            </PageHeader>

            <ToggleWrap>
                <ToggleButton type="button" $active={tab === 'CONFIGURED'} onClick={() => setTab('CONFIGURED')}>
                    Configurados
                </ToggleButton>
                <ToggleButton type="button" $active={tab === 'UNCONFIGURED'} onClick={() => setTab('UNCONFIGURED')}>
                    Não configurados
                </ToggleButton>
                <ToggleButton type="button" $active={tab === 'TEST'} onClick={() => setTab('TEST')}>
                    Cadastro/Teste
                </ToggleButton>
            </ToggleWrap>

            <Content>
                {tab === 'CONFIGURED' && <DevicesConfiguredList />}
                {tab === 'UNCONFIGURED' && <DevicesUnconfiguredList />}
                {tab === 'TEST' && <TestRegisterDevice />}
            </Content>
        </PageContainer>
    );
};

export default Devices;
